import httpClient from './httpClient';

export default {
    getMainBannerList() {
        return httpClient.get(`/banner/banners`);
    },
}
